// app/javascript/compcalc/components/About.jsx

import React from "react";
import PropTypes from "prop-types";
import { withStyles } from '@material-ui/core/styles';

import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';

import Link from '@material-ui/core/Link';
import Typography from '@material-ui/core/Typography';


const styles = theme => ({
  root: {
    flexGrow: 1,
    marginTop: theme.spacing(1),
  },
  wrapContent: {
    display: 'inline-block',
  },
  textField: {
    width: 100,
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  textFieldAmount: {
    width: 150,
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  alignCenter: {
    // background: 'green',
    textAlign: 'center',
    display: 'flex',
    flexFlow: 'column nowrap',
    justifyContent: 'center',    // Horizontal align.
    alignItems: 'center',        // Vertical align.
  },
  alignLeft: {
    // background: 'blue',
    display: 'flex',
    flexFlow: 'row nowrap',
    alignItems: 'center',
  },
  alignRight: {
    // background: 'red',
    display: 'flex',
    flexFlow: 'row-reverse nowrap',
    alignItems: 'center',
  },
  paperStretch: {
    padding: theme.spacing(2),
  },
  paper: {
    padding: theme.spacing(2),
    display: 'inline-block',
  },
  fixedWidth: {
    maxWidth: '800px',
    width: '100%',
  },
  pre: {
    width: '100%',
    maxWidth: '800px',
    whiteSpace: 'pre-wrap',
  }
});


class About extends React.PureComponent {

  constructor() {
    super();
  }

  componentDidMount = () => {
  }

  render() {
    const { classes } = this.props;

    return (

      <Grid container spacing={1} className={classes.root} justifyContent="center">

        <Grid item xs={12} className={`${classes.alignCenter} ${classes.fixedWidth}`}>
        {/*<Paper className={classes.paper}>*/}
          { global.config.isCompCalc &&
            <Typography variant="body1" paragraph>
            The Law Office of Richard L. Montarbo is entering its third decade as your Workers&apos; Compensation Defense source. Our goal is simply to provide the most aggressive representation of Insurance Carriers, Self-Insured Employers, and Public Entities in the Workers&apos; Compensation Industry. We balance our aggressive representation with our experience and knowledge which results in the highest quality of legal representation.
            </Typography>
          }

          <Typography variant="body1" paragraph>
            All users of this program are instructed to consult the specific provisions of the California Labor Code and/or the DEU to ensure the accuracy of the data and information provided. It is not the intent of the developers of this product to provide legal representation nor legal advice or opinion. All users of this program are instructed to consult with legal counsel before use.
          </Typography>

          { global.config.isCompCalc &&
            <div>
              <Typography variant="h6" paragraph>
                Areas of Expertise
              </Typography>
              <Typography variant="body1" paragraph>
                &bull; Workers Compensation Subrogation<br/>
                &bull; Disability retirement<br/>
                &bull; Public agency defense<br/>
                &bull; Mediations<br/>
                &bull; Workers Compensation Defense<br/>
                &bull; Employment and Labor Law<br/>
                &bull; Insurance Coverage<br/>
              </Typography>

              <Typography variant="h6" paragraph>
                Red Bluff Office
              </Typography>
              <Typography variant="body1" paragraph>
                146 Main Street<br/>
                Red Bluff, CA 96080<br/>
                530.529.9860 Office<br/>
                530.529.9865 Fax
              </Typography>

              <Typography variant="h6" paragraph>
                Sacramento Office
              </Typography>
              <Typography variant="body1" paragraph>
                3017 Douglas Blvd., Ste. 300<br/>
                Roseville, CA 95661<br/>
                916.774.7575 Office<br/>
                530.529.9865 Fax<br/>
              </Typography>

              <Typography variant="h6" paragraph>
                The Leader in Workers&apos;<br/>
                Compensation Litigation
              </Typography>

              <Typography variant="h6" paragraph>
                <Link href={'https://www.montarbolaw.com'} className={classes.link}>
                  MontarboLaw.com
                </Link>
              </Typography>
            </div>
          }

          { (global.config.isCompCalc || global.config.isAIG || global.config.isCAAA) &&
            <div>
              <Typography variant="h6" paragraph>
                App Developers:
              </Typography>
              <Typography variant="body1" paragraph>
                <Link href={'mailto:borzh62@gmail.com'} className={classes.link}>
                  Robert Godin
                </Link>
                <br/>
                <Link href={'mailto:casper777@gmail.com'} className={classes.link}>
                  Alex Gashper
                </Link>
                <br/>
                <Link href={'mailto:nestor.v.cuadrado@gmail.com'} className={classes.link}>
                  Nestor Cuadrado
                </Link>
                <br/>
                <Link href={'mailto:lassenranch@aol.com'} className={classes.link}>
                  Richard Montarbo
                </Link>
              </Typography>
            </div>
          }

          { (global.config.isAIG || global.config.isCAAA) &&
            <Typography variant="body2" paragraph>
              This program is part of the copyright protected CompCalc and remains the exclusive property of the Law Office of Richard Montarbo with all rights reserved, subject to a limited use license agreement granted to California Applicants&apos; Attorneys Association.
            </Typography>
          }

          { (global.config.isCompCalc) &&
            <Typography variant="body2" paragraph>
              CompCalc and CompCalc Plus are copyrighted and trademarked and are properties of the Law Office of Richard L. Montarbo with all rights reserved. Copyright &#9400; 2024 Montarbo Law.
            </Typography>
          }

          { (!global.config.isCompCalc && !global.config.isCAAA && !global.config.isAIG) &&
          <div>
            <Typography variant="body2" paragraph>
              Matrix CompCalc is copyrighted and trademarked and is property of the Matrix Document Imaging with all rights reserved. Copyright &#9400; 2024 Matrix Document Imaging.
            </Typography>

            <Typography variant="h6" paragraph>
              <Link href={'https://legal-records.us/about-us'} className={classes.link}>
                About Us
              </Link>
            </Typography>
          </div>
          }
        {/*</Paper>*/}
        </Grid>

      </Grid>
    );
  }

};

export default withStyles(styles)(About);
